import React from "react";
import { connect } from "react-redux";
import "./_Necklace.scss";
import { withRouter } from "react-router-dom";
import queryString from "query-string";

class Necklace extends React.Component {
  getCurrentMaterial = () => {
    const { history } = this.props;
    const queryParams = history
      ? queryString.parse(history.location.search)
      : null;
    if (queryParams) {
      return queryParams["necklace-material"];
    } else {
      return "yellow-gold";
    }
  };

  renderNecklace = (activeNecklace, memories) => {
    const currentNecklaceMaterial = this.getCurrentMaterial();
    if (currentNecklaceMaterial) {
      let necklaceImageUrl = null;
      if (activeNecklace) {
        switch (currentNecklaceMaterial) {
          case "rose-gold":
            necklaceImageUrl = activeNecklace.fields.imageRoseGoldURL;
            break;
          case "white-gold":
            necklaceImageUrl = activeNecklace.fields.imageWhiteGoldURL;
            break;
          default:
            necklaceImageUrl = activeNecklace.fields.imageYellowGoldURL;
            break;
        }
      }
      return (
        <div className="necklace-images" id="necklaces">
          {necklaceImageUrl ? (
            <img
              src={necklaceImageUrl}
              className="main-necklace"
              alt="Necklace"
            />
          ) : null}
          {this.renderMemories(memories)}
        </div>
      );
    }
  };

  renderMemories = (memories) => {
    if (memories && memories.length) {
      return memories.map((item) => {
        if (item && item.memory && item.index) {
          let materialKey = null;
          let className = `memory memory-${item.index}`;
          if (memories.length === 1) {
            className += " memory-single";
          }
          if (memories.length > 7) {
            className += " memory-side";
            // Render memories facing side
            materialKey = this.getMemoryMaterial(item.index, "side");
          } else {
            // Render memories in facing up
            materialKey = this.getMemoryMaterial(item.index, "main");
          }
          if (materialKey) {
            const imageURL = item.memory.fields
              ? item.memory.fields[materialKey]
              : null;
            if (imageURL) {
              return (
                <img
                  src={imageURL}
                  className={className}
                  alt={item.memory.fields.title}
                  key={`${item.index}-${item.memory.fields.title}`}
                />
              );
            } else {
              return null;
            }
          } else {
            return null;
          }
        } else {
          return null;
        }
      });
    } else {
      return null;
    }
  };

  getMemoryMaterial = (index = 1, type = "main") => {
    const { history } = this.props;
    const queryParams = history
      ? queryString.parse(history.location.search)
      : null;
    const key = `mm${index}`;
    if (queryParams) {
      if (type === "main") {
        switch (queryParams[key]) {
          default:
            return "imageYellowGoldMainURL";
          case "rose-gold":
            return "imageRoseGoldMainURL";
          case "white-gold":
            return "imageWhiteGoldMainURL";
        }
      } else {
        switch (queryParams[key]) {
          default:
            return "imageYellowGoldSideURL";
          case "rose-gold":
            return "imageRoseGoldSideURL";
          case "white-gold":
            return "imageWhiteGoldSideURL";
        }
      }
    }
  };

  render() {
    const { activeNecklace, activeMemories } = this.props;
    return (
      <div className="necklace">
        {this.renderNecklace(activeNecklace, activeMemories)}
      </div>
    );
  }
}

const mapStateToProps = ({ necklace }) => {
  const { activeNecklace, activeMemories } = necklace;

  return {
    activeNecklace,
    activeMemories,
  };
};

export default connect(mapStateToProps, {})(withRouter(Necklace));
